module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"<span class=\\"color-green\\">Press</span> review"},"fr":{"title":"Revue de <span class=\\"color-green\\">presse</span>"}}')
  delete Component.options._Ctor
}
